/** access correct env variable */
export const CURRENT_APP_STAGE = process.env.APP_STAGE || process.env.NEXT_PUBLIC_APP_STAGE || 'development';
export const IS_LOCAL = process.env.NODE_ENV === 'development';
export const CURRENT_API_STAGE = process.env.API_STAGE || process.env.NEXT_PUBLIC_API_STAGE || 'staging';

/**
 * App stages enumeration
 * @enum {string}
 * @export
 */
export enum APP_STAGE {
	DEVELOPMENT = 'development',
	PRODUCTION = 'production',
	STAGING = 'staging',
	BETA = 'beta',
}

/** runtime stage environment checks */
export const IS_PRODUCTION: boolean = CURRENT_APP_STAGE === APP_STAGE.PRODUCTION;
export const IS_DEVELOPMENT: boolean = CURRENT_APP_STAGE === APP_STAGE.DEVELOPMENT || CURRENT_APP_STAGE === undefined;
export const IS_STAGING: boolean = CURRENT_APP_STAGE === APP_STAGE.STAGING;
export const IS_BETA: boolean = CURRENT_APP_STAGE === APP_STAGE.BETA;
